import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCD-o5O2oHudGzxOrqaT-igJhOHyPx9I1s",
  authDomain: "oseela-3a6b3.firebaseapp.com",
  databaseURL: "https://oseela-3a6b3.firebaseio.com",
  projectId: "oseela-3a6b3",
  storageBucket: "oseela-3a6b3.appspot.com",
  messagingSenderId: "543609964913",
  appId: "1:543609964913:web:4103f21e0a655f83"
};
firebase.initializeApp(firebaseConfig);
